export const PAYOUT_STATUS_NOT_FOR_PAYOUT = 1;
export const PAYOUT_STATUS_READY_FOR_PAYOUT = 2;
export const PAYOUT_STATUS_PARTIALLY_PAID_OUT = 3;
export const PAYOUT_STATUS_PAYOUT_COMPLETED = 4;
export const PAYOUT_STATUS_CANCELLED = 5;

export const PARTIAL_PAYOUT_REQUEST_STATUS_PENDING = 1;
export const PARTIAL_PAYOUT_REQUEST_STATUS_PARTIALLY_PAID_OUT = 2;
export const PARTIAL_PAYOUT_REQUEST_STATUS_FULLY_PAID_OUT = 3;
export const PARTIAL_PAYOUT_REQUEST_STATUS_CANCELLED = 4;
export const PARTIAL_PAYOUT_REQUEST_STATUS_PAID_OUT = 9;



// WEBPACK FOOTER //
// ./src/HOCs/Constants/DatabaseEnums.js